module.exports = __webpack_public_path__ + "img/qr-code-android.83ee7d8b.png";